export enum BankAccountTypes {
  PERSONAL_CHECKING = 'personal-checking',
  PERSONAL_SAVINGS = 'personal-savings',
  BUSINESS_CHECKING = 'business-checking',
  BUSINESS_SAVINGS = 'business-savings'
}
